
import axiosClient from "../../../../../../api/axiosClient";

const BASE_URL = "/api/ppe/material-flow/inventory/reports";

export const fetchRawMaterialMaster = async (filters = {}) => {
  const params = {};

  Object.entries(filters).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      value !== "all"
    ) {
      params[key] = value;
    }
  });

  const response = await axiosClient.get(
    `${BASE_URL}/raw-material-master`,
    { params }
  );

  return response.data?.data || {
    columns: [],
    rows: [],
    total_rows: 0,
  };
};

export const exportRawMaterialMasterExcel = async (filters = {}) => {
  const params = {};

  Object.entries(filters).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      value !== "all"
    ) {
      params[key] = value;
    }
  });

  const response = await axiosClient.get(
    `${BASE_URL}/raw-material-master/excel`,
    {
      params,
      responseType: "blob",
    }
  );

  return response.data;
};
